import { Breadcrumbs } from "@/components/ui/breadcrumbs";
import { H2 } from "@/components/ui/typography";
import { SubdistrictEditForm } from "@/features/subdistrict/SubdistrictEditForm";
import { MISSING_ID_IN_ROUTE } from "@/utils/constant";
import { useParams } from "react-router-dom";

export function SubdistrictEdit() {
  const { id } = useParams();
  if (!id) {
    throw new Error(MISSING_ID_IN_ROUTE);
  }

  return (
    <>
      <Breadcrumbs
        list={[
          {
            label: "Master Data",
          },
          {
            href: "/master-data/district",
            label: "District (Kec)",
          },
          {
            label: "Edit",
          },
        ]}
      />
      <H2>Edit District (Kec)</H2>
      <SubdistrictEditForm id={id} />
    </>
  );
}
